export default __webpack_public_path__ + "static/media/bb-00013.f429c706.png";